import { z } from "zod";

/**
 * The one field a picker types when booking a pick. The article and the shelf are not here: the
 * round already knows which line it is on, and the shelf came from the label that was scanned.
 *
 * There is no upper bound. What the line owes is runtime data, and it is not a ceiling anyway:
 * booking past it is allowed, so a site that rings up needing ten more gets them on this round.
 * `PickQuantityBottomSheet` calls the overage out and `insertSuborderPick` books it.
 */
export const pickQuantitySchema = z.object({
	quantity: z.coerce.number().int().positive(),
});

export type PickQuantityFormSchema = z.infer<typeof pickQuantitySchema>;
